module.exports = __webpack_public_path__ + "static/media/1.f9eea2ee.jpeg";